const homeApiErrorMessages = {
  failed_to_load_accounts: 'Failed to get accounts.',
};

const chatApiErrorMessages = {
  failed_to_load_chat: 'Failed to get Chat account details.',
  failed_to_remove_chat: 'Failed to remove Chat account.',
};

const abcApiErrorMessages = {
  failed_to_remove_abc: 'Failed to remove Apple Messages for Business account.',
  failed_to_get_abc: 'Failed to get Apple Messages for Business account details.',
};

const facebookApiErrorMessages = {
  failed_to_remove_facebook: 'Failed to remove Facebook page.',
  failed_to_load_facebook: 'Failed to get Facebook account details.',
  failed_to_authorize_facebook: 'Unable to authorize facebook account.',
};

const twitterApiErrorMessages = {
  failed_to_remove_twitter: 'Failed to remove Twitter page.',
  failed_to_load_twitter: 'Failed to get Twitter account details.',
  failed_to_authorize_twitter: 'Unable to authorize twitter account.',
};

const twilioApiErrorMessages = {
  failed_to_remove_twilio: 'Failed to remove Twilio account.',
  failed_to_load_twilio: 'Failed to get Twilio account details.',
  failed_to_update_twilio: 'Failed to update Twilio Whatsapp account details.',
};
const twilioWhatsAppApiErrorMessages = {
  failed_to_remove_whatsapp: 'Failed to remove Twilio Whatsapp account.',
  failed_to_load_whatsapp: 'Failed to get Twilio Whatsapp account details.',
};

const thirdpartyApiErrorMessages = {
  failed_to_remove_connection: 'Failed to remove account.',
  failed_to_load_connection: 'Failed to get account details.',
  failed_to_update_simulator_configuration: 'Failed to update simulator configurations.',
  failed_to_update_connection: 'Failed to update connection and GenAI configurations.',
};

const vonageWhatsAppApiErrorMessages = {
  failed_to_remove_vonage_whatsapp: 'Failed to remove Vonage Whatsapp account.',
  failed_to_load_vonage_whatsapp: 'Failed to get Vonage Whatsapp account details.',
};

const vonageSmsApiErrorMessages = {
  failed_to_remove_vonage_sms: 'Failed to remove Vonage SMS account.',
  failed_to_load_vonage_sms: 'Failed to get Vonage SMS account details.',
};

const errorLogsTableTranslation = {
  econnrefused: 'messaging endpoint unreachable (ECONNREFUSED)',
  ehostunreach: 'messaging endpoint unreachable (EHOSTUNREACH)',
  etimedout: 'messaging endpoint unreachable (ETIMEDOUT)',
  econnreset: 'messaging endpoint unreachable (ECONNRESET)',
  socket_hang_up: 'messaging endpoint socket request was ended',
  timed_out: 'messaging endpoint did not return response within 30 secs',
  error_code_5xx: 'messaging endpoint returned an internal error on server or application',
  status_code_4xx: 'messaging endpoint returned an unreachable, not found, or not authorized status error',
  unknown_error: 'request failed',
};

const apiErrorTranslations = {
  ...homeApiErrorMessages,
  ...chatApiErrorMessages,
  ...abcApiErrorMessages,
  ...facebookApiErrorMessages,
  ...twitterApiErrorMessages,
  ...twilioApiErrorMessages,
  ...twilioWhatsAppApiErrorMessages,
  ...thirdpartyApiErrorMessages,
  ...vonageWhatsAppApiErrorMessages,
  ...vonageSmsApiErrorMessages,
  ...errorLogsTableTranslation,
};

export default apiErrorTranslations;
